import React from "react";
const SPOTS_LEFT = 7;
const FILLED = 93;
export function ScarcityBar() {
  return <div className="mt-6 rounded-2xl border border-alert/30 bg-alert/10 p-4" data-id="element-52" data-mp="2yw2we7coll1d">
      <div className="flex items-center justify-between gap-3" data-id="element-53" data-mp="2yy5k2kqd322x">
        <p className="flex items-center gap-2 text-sm font-extrabold text-alert" data-id="element-54" data-mp="2l4elg7e652lz">
          <span className="relative flex h-2.5 w-2.5" aria-hidden="true" data-id="element-55" data-mp="2q2zcphbg0bya">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-alert opacity-75" data-id="element-56" data-mp="2b68m9xjqyakt" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-alert" data-id="element-57" data-mp="2g63a1s886k1n" />
          </span>
          Only {SPOTS_LEFT} spots left at $27
        </p>
        <span className="text-sm font-black text-navy" data-id="element-58" data-mp="228enmfyif4uh">{FILLED}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-navy/10" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-59" data-mp="27796tj0e2vf4">
        <div className="bar-stripes h-full rounded-full bg-alert" style={{
        width: `${FILLED}%`
      }} data-id="element-60" data-mp="33m3az7x65bex" />
      </div>
      <p className="mt-2 text-xs font-medium text-navy/70" data-id="element-61" data-mp="2zk88w17eyu03">
        When the remaining spots are claimed, the price returns to its regular value.
      </p>
    </div>;
}